import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "../features/auth/AuthProvider";
import { AppErrorBoundary } from "./AppErrorBoundary";
import { router } from "./router";
import { NetworkStatus } from "../shared/ui/NetworkStatus";
import { OperationCompletionDialog } from "../shared/ui/OperationCompletionDialog";
import { notifyOperationCompleted } from "../shared/ui/operationCompletion";

export function createAppQueryClient() {
  return new QueryClient({
    mutationCache: new MutationCache({
      onSuccess: () => notifyOperationCompleted(),
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
        throwOnError: true,
      },
      mutations: { retry: 0 },
    },
  });
}

const queryClient = createAppQueryClient();

export function AppProviders() {
  return (
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <NetworkStatus />
        <OperationCompletionDialog />
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </AppErrorBoundary>
  );
}
